import React from "react";
import _ from "lodash";

import Button from "@mui/material/Button";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

import { StatusChip } from "@akj-dev/shared-components";

import { Spinner } from "../../../../shared/components/Spinner";

interface ChooseWlrAppointmentProps {
  appointments: Record<string, any>;
  addWlrAppointment: Record<string, any>;
  isSalesPerson: boolean;
  onChooseWlrAppointment: (event: SelectChangeEvent<any>) => void;
  onRetry: () => void;
  onAddAppointment: () => void;
}

export const ChooseWlrAppointment = ({
  appointments,
  addWlrAppointment,
  isSalesPerson,
  onAddAppointment,
  onChooseWlrAppointment,
  onRetry,
}: ChooseWlrAppointmentProps) => {
  if (appointments.fetching)
    return (
      <StatusChip
        type="loading"
        title="Please Wait"
        message="Loading WLR Appointments"
      />
    );

  if (_.get(appointments.response, "status") === "error")
    return (
      <StatusChip
        type="error"
        title="Sorry"
        message="Something went wrong fetching WLR appointments."
        retry={onRetry}
      />
    );

  return (
    <div>
      <FormControl fullWidth margin="normal">
        <InputLabel variant="standard">
          Choose your WLR Appointment time
        </InputLabel>
        <Select
          variant="standard"
          onChange={onChooseWlrAppointment}
          value={appointments.selectedIndex}
          style={{ width: "100%" }}
          disabled={
            addWlrAppointment.fetching ||
            addWlrAppointment?.response.status === "success"
          }
          data-cy="wlrAppointmentSelect"
        >
          <MenuItem />
          {appointments?.response.appointments.map((a: any, i: number) => (
            <MenuItem value={i} key={a.string}>
              {a.string}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {appointments.selectedIndex !== null && (
        <p>
          This appointment date is only reserved for 4 hours. If the contract is
          signed after 4 hour of receipt the next available appointment will be
          given.
        </p>
      )}
      {
        // TP32603: If the user is a sales person, then actual reserving of
        // the appointment will take place later, after account creation and
        // just before ordering of the products.
        !isSalesPerson && (
          <Button
            variant="contained"
            color="secondary"
            endIcon={
              addWlrAppointment.fetching && <Spinner size={30} color="#aaa" />
            }
            onClick={onAddAppointment}
            disabled={
              addWlrAppointment.fetching ||
              addWlrAppointment?.response.status === "success" ||
              appointments.selectedIndex === null
            }
            data-cy="reserveWlrAppointment"
          >
            Reserve WLR Appointment
          </Button>
        )
      }
      {addWlrAppointment?.response.status === "success" && (
        <StatusChip
          type="success"
          title="Appointment Reserved"
          message={`Reference: ${addWlrAppointment?.response.appointment_reference}`}
          style={{ marginTop: 20 }}
        />
      )}
      {addWlrAppointment?.response.status === "error" && (
        <StatusChip
          type="error"
          title="Sorry"
          message="Something went wrong reserving your WLR appointment."
        />
      )}
    </div>
  );
};
